import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonIcon,
  IonSpinner,
  IonText,
} from '@ionic/react';
import {
  peopleOutline,
  radioOutline,
  notificationsOutline,
  waterOutline,
  mailOutline,
  arrowForward,
  leafOutline,
  shieldCheckmarkOutline,
  sparklesOutline,
  wifiOutline,
  cloudDownloadOutline,
} from 'ionicons/icons';
import CountUp from '../../components/CountUp';
import { useAdminHome } from '../../../application/use-cases/admin/useAdminHome';
import '../Settings.css';
import './Admin.css';

const SECTIONS = [
  { href: '/app/admin/users', icon: peopleOutline, label: 'Usuarios', hint: 'Admins, accesos y contraseñas', tone: 'green' },
  { href: '/app/admin/devices', icon: radioOutline, label: 'Estaciones', hint: 'Origen de datos y salud', tone: 'blue' },
  { href: '/app/admin/hubs', icon: wifiOutline, label: 'Hubs', hint: 'Stock, dueños y salud', tone: 'green' },
  { href: '/app/admin/firmware', icon: cloudDownloadOutline, label: 'Firmware', hint: 'Actualizar los hubs a distancia', tone: 'violet' },
  { href: '/app/admin/lots', icon: leafOutline, label: 'Lotes', hint: 'Cultivos y etapas', tone: 'brown' },
  { href: '/app/admin/alerts', icon: notificationsOutline, label: 'Alertas', hint: 'Configuradas y disparadas', tone: 'red' },
  { href: '/app/admin/irrigation', icon: waterOutline, label: 'Riego', hint: 'Horarios y riegos', tone: 'violet' },
  { href: '/app/admin/emails', icon: mailOutline, label: 'Emails', hint: 'Lo que salió y lo que falló', tone: 'orange' },
  { href: '/app/admin/ai', icon: sparklesOutline, label: 'IA', hint: 'Tokens, prompts y llamadas', tone: 'blue' },
];

const AdminHome: React.FC = () => {
  const history = useHistory();
  const { stats, error, loading } = useAdminHome();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/settings" />
          </IonButtons>
          <IonTitle>Backoffice</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        {loading && (
          <div className="ion-text-center">
            <IonSpinner color="primary" />
          </div>
        )}
        {error && (
          <IonText color="danger">
            <p>{error}</p>
          </IonText>
        )}

        <div className="profile-card admin-hero">
          <span className="profile-avatar">
            <IonIcon icon={shieldCheckmarkOutline} />
          </span>
          <span>
            <strong>Backoffice</strong>
            <small>Todo DomIoT de un vistazo</small>
          </span>
        </div>

        {stats && (
          <div className="admin-stats-grid">
            <div className="admin-stat-tile tone-green">
              <IonIcon icon={peopleOutline} />
              <span className="admin-stat-value">
                <CountUp value={String(stats.users)} />
              </span>
              <span className="admin-stat-label">Usuarios</span>
            </div>
            {/* "Transmitiendo" = mandaron datos hace poco (no alcanza con que estén prendidas). */}
            <div className="admin-stat-tile tone-blue">
              <IonIcon icon={radioOutline} />
              <span className="admin-stat-value">
                <CountUp value={String(stats.devicesOnline)} />
                <small> de {stats.devices}</small>
              </span>
              <span className="admin-stat-label">Estaciones transmitiendo</span>
              <span className="admin-stat-detail">
                {stats.devicesSilent} sin conexión · {stats.devicesNeverReported} nunca mandaron datos
              </span>
            </div>
            <div className="admin-stat-tile tone-red">
              <IonIcon icon={notificationsOutline} />
              <span className="admin-stat-value">
                <CountUp value={String(stats.alertsTriggered)} />
              </span>
              <span className="admin-stat-label">Alertas disparadas</span>
            </div>
            <div className="admin-stat-tile tone-violet">
              <IonIcon icon={waterOutline} />
              <span className="admin-stat-value">
                <CountUp value={String(stats.irrigationSchedulesActive)} />
              </span>
              <span className="admin-stat-label">Horarios de riego activos</span>
            </div>
            <div className="admin-stat-tile tone-orange">
              <IonIcon icon={mailOutline} />
              <span className="admin-stat-value">
                <CountUp value={String(stats.emailsLast24h)} />
              </span>
              <span className="admin-stat-label">Emails (24h)</span>
            </div>
          </div>
        )}

        <p className="settings-eyebrow">Administrar</p>
        <div className="admin-nav">
          {SECTIONS.map((section) => (
            <button key={section.href} className={`admin-nav-tile tone-${section.tone}`} onClick={() => history.push(section.href)}>
              <span className="admin-nav-icon">
                <IonIcon icon={section.icon} />
              </span>
              <strong>{section.label}</strong>
              <small>{section.hint}</small>
              <IonIcon icon={arrowForward} className="admin-nav-go" />
            </button>
          ))}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default AdminHome;
